import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { UpsertPublicPhoneComponent } from "@/components/assist/phone/upsert-public-phone";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";

import type { JSX } from "react";

const UpsertPublicPhonePageQuery = graphql(/* GraphQL */ `
  query UpsertPublicPhonePageQuery {
    ...UpsertPublicPhoneFragment
  }
`);

const UpsertPublicPhonePage = (): JSX.Element => {
  const queryResult = useGraphQL(UpsertPublicPhonePageQuery, {});
  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Telefone para paciente" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <UpsertPublicPhoneComponent data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/upsert-public-phone/")({
  component: UpsertPublicPhonePage,
});
